export default "/packs/images/DSC05596~f46da1e3be96a7bc7a5c059792e1fb98.jpg";